import { useEffect } from 'react';

import { type Theme, usePreferences } from '@rootsight/shared';

/**
 * applyTheme pins <html data-theme> to the operator's choice, or removes it
 * for "system" so the tokens follow the operating system through
 * prefers-color-scheme. Call it before the first render with storedTheme()
 * so a dark-mode operator never sees a white flash.
 */
export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (theme === 'system') {
    delete root.dataset.theme;
  } else {
    root.dataset.theme = theme;
  }
}

/** useThemeSync keeps the document's theme in step with the saved preference.
 * Mount it once, at the app's root. */
export function useThemeSync(): void {
  const theme = usePreferences((s) => s.theme);
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
}
